export class Step1 {
    constructor() {}

    intitule = 'stepper.form.mapa_an.step1';
    getspan1 = 'form.mapa_an.getspan1';
    getidWeb = 'form.mapa_an.getidWeb';
    getdatepublication = 'form.mapa_an.getdatepublication';

}
